import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { connect } from "react-redux";

const MenuItem = ({ title, to, activeOnlyWhenExact }) => (
  <Link
    title={title}
    className="menu-item"
    activeClassName="active"
    to={to}
    activeOnlyWhenExact={activeOnlyWhenExact}
  >
    {title}
  </Link>
);

class Menu extends React.Component {
  constructor() {
    super();
  }

  render() {
    const { appPath } = this.props;

    return (
      <div className="menu-top">
        <MenuItem
          title="Oferty pracy"
          activeOnlyWhenExact
          to={appPath || "/"}
        />
        <MenuItem title="Porady dla opiekunek" to={`${appPath}/blog`} />
        <MenuItem title="Kontakt" to={`${appPath}/kontakt`} />
      </div>
    );
  }
}

export default connect(
  state => ({
    appPath: state.config.appPath
  }),
  {}
)(Menu);



/** WEBPACK FOOTER **
 ** ./src/browser/components/Header/Menu.js
 **/